import {deleteTaskList as deleteTaskListGQL} from "../gql/mutations";
import {TaskListUnit} from "../gql/serverTypes";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";

export const deleteTaskList = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    taskListUnitId: string,
    taskListId: string,
    version: number,
): Promise<TaskListUnit> => {
    const deletedValue = await queryGqlApi(
        deleteTaskListGQL,
        {
            input: { taskListUnitId, taskListId, version },
        },
        dataClientService,
        authService,
        'pgServer'
    );
    return deletedValue as unknown as TaskListUnit;
};
